/**
 * @generated SignedSource<<d24e73d9a9eb217b539b0ed0b990d4b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZendeskProviderQuery$variables = Record<PropertyKey, never>;
export type ZendeskProviderQuery$data = {
  readonly zendeskJwtToken: {
    readonly token: string;
  };
};
export type ZendeskProviderQuery = {
  response: ZendeskProviderQuery$data;
  variables: ZendeskProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ZendeskJwtOutput",
    "kind": "LinkedField",
    "name": "zendeskJwtToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ZendeskProviderQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ZendeskProviderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "23cd3771806efaba7fc9c3060b32fcb1",
    "id": null,
    "metadata": {},
    "name": "ZendeskProviderQuery",
    "operationKind": "query",
    "text": "query ZendeskProviderQuery {\n  zendeskJwtToken {\n    token\n  }\n}\n"
  }
};
})();

(node as any).hash = "9134e53c1892e8fcb0dc421e2cc1954c";

export default node;
